var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "home", attrs: { id: "page" } },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6", "offset-md": "3" } }, [
                _c("div", { staticClass: "home-panel" }, [
                  _c(
                    "div",
                    { staticClass: "home-logo" },
                    [
                      _c(
                        "b-link",
                        { attrs: { to: { name: "home" } } },
                        [_c("logo")],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "home-buttons" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            block: "",
                            variant: "primary",
                            href: _vm.applyUrl,
                          },
                        },
                        [_vm._v("Apply for Membership")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            block: "",
                            variant: "outline-primary",
                            to: { name: "login" },
                          },
                        },
                        [_vm._v("Login")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }